import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { Emitter } from '@patsnap/tahiti-core/common/event';
import type { UserPreRedirectLoginService } from '../user-pre-redirect-login';

@injectable()
export class UserPreRedirectLoginServiceImpl implements UserPreRedirectLoginService {
  private _onStatesChangeEmitter = new Emitter<boolean>();
  public readonly onStatesChange = this._onStatesChangeEmitter.event;
  private _isKickedOut = false;

  get isKickedOut() {
    return this._isKickedOut;
  }

  private _emitKickedLogoutChange() {
    this._isKickedOut = true;
    this._onStatesChangeEmitter.fire(true);
  }

  public updateKickedOut() {
    this._emitKickedLogoutChange();
  }
}
